export default "<a type=\"button\" (click)=\"invokeDownload()\" class=\"downloadLink\"> View </a>\n";